import { Divider, Skeleton, Stack } from '@mui/material'

function LoadingSection() {
  return (
    <Stack spacing={1.5}>
      <Skeleton variant="rounded" width={138} height={9} />
      <Skeleton variant="rounded" width="100%" />
    </Stack>
  )
}

export function BodyLoading() {
  return (
    <Stack height="75vh" overflow="hidden" spacing={2} padding={2}>
      <LoadingSection />
      <Divider />

      <LoadingSection />
      <Divider />

      <LoadingSection />
      <Divider />

      <LoadingSection />
      <Divider />

      <LoadingSection />
      <Divider />

      <LoadingSection />

      <LoadingSection />

      <LoadingSection />
    </Stack>
  )
}
